import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Button,
  Box,
} from "@mui/material";
import Card, { LoaderWrapper } from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../../components/LayoutWrapper/LayoutWrapper";
import { useSelections } from "../../../context/Selections";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { KpisAreaAtuacao } from "../../../components/KPIsInsights/KPIsAreaAtuacao";
import CircleLoader from "../../../components/Loaders/CircleLoader";

function InsightsAreaDesktop({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setselectedValue] = useState("Cuidados com a pele");
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [textQuarter, setTextQuarter] = useState();
  const [textQuarterOne, setTextQuarterOne] = useState();
  const [textQuarterTwo, setTextQuarterTwo] = useState();
  const [textQuarterThree, setTextQuarterThree] = useState();
  const [textQuarterFoor, setTextQuarterFoor] = useState();
  const [showGraph, setShowGraph] = useState(false);

  function handleChange(value) {
    app.field("Agrp").selectMatch(value);
  }

  const fetchKPIValueShowGraph = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setShowGraph(value > 0 ? true : false);
        });
      }
    },
    [app, setTextQuarter]
  );

  const fetchKPIValue = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          if (!position) {
            setTextQuarter(value && value[0] !== "-" ? value : null);
          } else {
            position === 1 &&
              setTextQuarterOne(value && value[0] !== "-" ? value : null);
            position === 2 &&
              setTextQuarterTwo(value && value[0] !== "-" ? value : null);
            position === 3 &&
              setTextQuarterThree(value && value[0] !== "-" ? value : null);
            position === 4 &&
              setTextQuarterFoor(value && value[0] !== "-" ? value : null);
          }
        });
      }
    },
    [app, setTextQuarter]
  );

  useEffect(() => {
    if (app) {
      const visaoField = selections.find((s) => s.qField === "Agrp");
      setselectedValue(visaoField?.qSelected);
      fetchKPIValue("jzfBCy");
      fetchKPIValue("HJmznE", 1);
      fetchKPIValue("aerRs", 2);
      fetchKPIValue("FZfyru", 3);
      fetchKPIValue("vrDEU", 4);

      fetchKPIValueShowGraph("mvhqEX");
    }
  }, [app, selections]);

  const exportToXLS = async (objectId, isContainer) => {
    setLoadingExcel(true);
    let id = objectId;

    if (isContainer) {
      await app.visualization
        .get(objectId)
        .then((vis) => {
          id = vis.model.items.activeId;
        })
        .catch(() => setLoadingExcel(false));
    }

    if (app && id) {
      await app.visualization
        .get(id)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            const xlsLink = `https://qsense.mtrix.com.br${
              process.env.REACT_APP_PREFIX
            }${link.substring(link.indexOf("tempcontent"))}`;
            window.open(xlsLink);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  return (
    <div className="app insightstArea">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container width={"100%"}>
            <Grid className="container-line-one-insights">
              <span className="title-form"> Agrupamento estratégico </span>
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Cuidados com a Pele"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={(e) => handleChange(e.target.value)}
                  sx={{ marginLeft: "20px" }}
                >
                  <FormControlLabel
                    value="Cuidados com a Pele"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados com a pele"
                  />

                  <FormControlLabel
                    value="Esmaltes"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Esmaltes"
                  />

                  <FormControlLabel
                    value="Cuidados Pessoais"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados Pessoais"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid width={"100%"}>
              <Grid className="container-part-one-line-one-insights">
                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: `Quanto tempo falta para fechar ${textQuarter}?`,
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"apfeGj"}
                      idNumberSecond={"Tftcx"}
                      idPercentageProgress={"XMnhjEd"}
                      idNumberPercentage={"XMnhjEd"}
                      days
                    />
                  </Card>
                </Grid>

                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Como estamos em relação à meta?",
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"SdRcpu"}
                      idNumberSecond={"BnPbbP"}
                      idPercentageProgress={"XMnhjEd"}
                      idNumberPercentage={"ddmLEJV"}
                    />
                  </Card>
                </Grid>
              </Grid>

              {showGraph && (
                <Grid className="container-part-dois-line-two">
                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quantos distribuidores estão abaixo ou acima da meta?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="mfMm"
                      type={"table"}
                      reference={{
                        id: "mfMm",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",

                        width: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quais distribuidores puxam o resultado para baixo?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="hNGpGA"
                      type={"table"}
                      reference={{
                        id: "hNGpGA",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",
                        width: "100%",
                      }}
                    />
                  </Card>
                </Grid>
              )}
            </Grid>
            <Grid className="container-last-line-insights">
              {showGraph && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Performance",
                  }}
                >
                  <ul className="container-legenda">
                    <li className="text-quadrado">legenda</li>
                    <li>
                      <span className="quadrado sell"></span>
                      <span className="text-quadrado">
                        <span className="text">Sell out de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>

                    <li>
                      <span className="quadrado media"></span>
                      <span className="text-quadrado">
                        Média nos Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado maxima"></span>
                      <span className="text-quadrado">
                        Máxima realizada em Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado meta"></span>
                      <span className="text-quadrado">
                        <span className="text">Meta de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>
                  </ul>
                  <NativeObject
                    app={app}
                    key="MgZQEq"
                    type={"table"}
                    reference={{
                      id: "MgZQEq",
                    }}
                    style={{
                      padding: "0",
                      height: "300px",
                      width: "100%",
                    }}
                  />
                </Card>
              )}

              <Card
                app={app}
                header={{
                  hardTitle: "Onde atacar e o que vender",
                }}
              >
                <Grid className="container-last-line-objects">
                  <div>
                    <div className="container-line-export-button export-button-onde-atacar">
                      <Grid
                        className="container-periodo"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        xs
                      >
                        <p style={{ height: "30px" }}>
                          Não comprou em {textQuarterOne}, mas comprou em{" "}
                          {textQuarterTwo} e/ou {textQuarterThree} e/ou{" "}
                          {textQuarterFoor}
                        </p>
                      </Grid>

                      <Tooltip title="Exportar para Excel">
                        <Button
                          type="button"
                          onClick={() => exportToXLS("rAnJ", true)}
                          endIcon={<FileDownloadOutlinedIcon />}
                          className="export-button"
                        >
                          {!loadingExcel ? (
                            <Box component={"span"}>
                              Exportar Lista Completa
                            </Box>
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </Button>
                      </Tooltip>
                    </div>
                    <NativeObject
                      app={app}
                      key="rAnJ"
                      type={"table"}
                      reference={{
                        id: "rAnJ",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",
                        width: "100%",
                      }}
                    />
                  </div>

                  <div>
                    <div className="container-line-export-button export-button-onde-atacar">
                      <Grid
                        className="container-periodo"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        xs
                      >
                        <p style={{ height: "30px" }}>
                          Comprou em {textQuarterOne}, mas abaixo de 30% da
                          média dos quarters anteriores ({textQuarterTwo} +{" "}
                          {textQuarterThree} + {textQuarterFoor})
                        </p>
                      </Grid>

                      <Tooltip title="Exportar para Excel">
                        <Button
                          type="button"
                          variant="outlined"
                          onClick={() => exportToXLS("mMFWXk", true)}
                          endIcon={<FileDownloadOutlinedIcon />}
                          className="export-button"
                        >
                          {!loadingExcel ? (
                            <Box component={"span"}>
                              Exportar Lista Completa
                            </Box>
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </Button>
                      </Tooltip>
                    </div>
                    <NativeObject
                      app={app}
                      key="mMFWXk"
                      type={"table"}
                      reference={{
                        id: "mMFWXk",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",

                        width: "100%",
                      }}
                    />
                  </div>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

InsightsAreaDesktop.defaultProps = {
  app: null,
  config: {},
};

InsightsAreaDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InsightsAreaDesktop;
